<template>
  <v-sheet>
    <div
      v-if="!schedule || !teacher"
    >
      Schedule not found
    </div>
    <div class="text-h5 mb-2" v-else>
      Edit schedule for {{ teacher.firstName  }} {{ teacher.lastName  }}
    </div>

    <teacher-schedule-form
      :key="schedule.id"
      :teacher.sync="teacher"
      v-model="schedule"
      @clickedSave="saveSchedule"
      v-if="schedule"
    />
  </v-sheet>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from "vuex";
const TeacherScheduleForm = () =>
  import("@/components/teacher/TeacherScheduleForm.vue");

export default {
  components: { TeacherScheduleForm },
  props: {
    value: { 
      type: Object,
      required: true
    }
  },
  data: () => ({
    teacher: null,
    schedule: {},
    timestamp: Date.now()
  }),
  computed: {
    ...mapGetters(["navState", "isAppLoading", "currentUser"])
  },
  async mounted(){
    const scheduleId = this.value.id
    const scheduleType =  this.value.type
    const date = this.value.date; // Date is not required

    this.teacher = await this.getTeacher(this.value.staffId);
    this.schedule = await this.getSchedule(scheduleId, scheduleType, date);

    this.latestPayroll = await this.getLatestPayroll(scheduleId);
    console.log('latest payroll: ', this.latestPayroll)

    console.log('mounted: ', this.schedule, this.teacher)
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),
    async getSchedule(id, type, date) {
      if (id && type) {
        const result = await this.$axios
          .get("staff/schedule", { params: { schedule_id: id, staff_type: type, date } })

        const schedule = result.data;
        if(schedule.rrule){
          schedule.startDate = schedule.recurringStartDate;
          schedule.endDate = schedule.recurringEndDate;

          schedule.startTime = moment(schedule.startTime).format("HH:mm");
          schedule.endTime = moment(schedule.endTime).format("HH:mm");
          schedule.daysOfWeek = schedule.daysOfWeek ? schedule.daysOfWeek.split(",") : []
          if(this.teacher.hourlyRates && this.teacher.hourlyRates.length > 0){
            schedule.rateId = this.teacher.hourlyRates.find(e => e.hourlyRate == schedule.hourRate).id;
          }
        }
        return schedule;
      } else {
        return null;
      }
    },
    async getTeacher(teacherId) {
      if (teacherId) {
        const result = await this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })

        const t = result.data.data;
        return t;
      } else {
        return null;
      }
    },
    saveSchedule() {
      this.schedule.teacherId = this.teacher.id;
      console.log("clicked save schedule", this.schedule);
      this.$axios
        .post("teacher/save-schedule", this.schedule)
        .then(resp => {
          console.log("Saved schedule", resp);

          this.hideDialog();
          this.teacher = null;
          this.schedule = null;
        })
        .catch(error => {
          console.log("Error saving staff schedule", error);
          this.addErrorMessage("Error saving staff schedule");
          this.teacher = null;
          this.schedule = null;
        });
    },
    async getLatestPayroll(scheduleId){
      const params = { teacher_schedule_id: scheduleId}
      return this.$axios.get('payroll/teacher-schedule/latest-payroll', {params})
        .then(resp => {
          return resp.data;
        })
        .catch(error => {
          console.log("Error getting latest payroll", error);
          return null;
        })
    }
  }
};
</script>

<style></style>
